import {
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  SelectProps,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PeriodDTO } from '../../models/dto/PeriodDTO';
import { AppState } from '../../store/index';
import { CondominiumReducerData } from '../../store/reducers/condominiumReducer';

interface SelectPeriodProps extends SelectProps {
  value: PeriodDTO | null;
  showLabel?: boolean;
  handlePeriodChange: (periodSelected: PeriodDTO) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    selectButton: {
      textAlign: 'center',
    },
    selectMenu: {
      padding: 0,
      '&&:focus': {
        backgroundColor: 'transparent',
      },
    },
    menuPaper: {
      maxHeight: 350,
    },
  }),
);

const SelectPeriod: React.FC<SelectPeriodProps> = ({
  value,
  showLabel,
  handlePeriodChange,
  ...rest
}) => {
  const classes = useStyles();
  const [startedNewPeriod, setStartedNewPeriod] = useState<boolean>(false);

  const { periods, loading }: CondominiumReducerData = useSelector(
    (state: AppState) => state.condominiumReducer,
  );

  useEffect(() => {
    if (periods.length > 0) {
      if (
        moment().isBefore(moment(periods[0].inicioMesApuracao, 'DD/MM/YYYY'))
      ) {
        handlePeriodChange(value || periods[1]);
      } else {
        handlePeriodChange(value || periods[0]);
        setStartedNewPeriod(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periods]);

  return (
    <>
      {showLabel && (
        <Typography
          style={{ display: 'inline', fontWeight: 'bold', marginRight: 8 }}
          color="textPrimary"
          variant="body1"
        >
          Período de visualização:
        </Typography>
      )}
      <Select
        MenuProps={{ classes: { paper: classes.menuPaper } }}
        disabled={loading || periods.length === 0}
        classes={{
          root: classes.selectButton,
          selectMenu: classes.selectMenu,
          ...rest?.classes,
        }}
        value={value?.codigoInterno || 9999}
        {...rest}
      >
        {periods.length > 0 ? (
          periods
            .slice(startedNewPeriod ? 0 : 1, periods.length - 1)
            .map((period, index) => (
              <MenuItem
                key={index}
                value={period.codigoInterno}
                selected={period.codigoInterno === value?.codigoInterno}
                style={{ padding: 0 }}
              >
                <ListItem
                  component="nav"
                  onClick={(event: React.MouseEvent<HTMLElement>) => {
                    event.stopPropagation();
                    handlePeriodChange(period);
                  }}
                >
                  <ListItemText
                    primary={moment(period.mesFechamento, 'DD/MM/YYYY').format(
                      'MMMM / YYYY',
                    )}
                  />
                </ListItem>
              </MenuItem>
            ))
        ) : (
          <MenuItem value={9999} selected style={{ padding: 0 }}>
            <ListItem component="nav">
              <ListItemText primary="Carregando..." />
            </ListItem>
          </MenuItem>
        )}
      </Select>
    </>
  );
};

export default SelectPeriod;
